import type { PrecoPlanCard } from '../hooks/usePublicSaasPlans';

const PERIOD_DISCOUNT: Record<string, number> = {
  mensal: 0,
  trimestral: 0.05,
  semestral: 0.1,
  anual: 0.15,
};

export function computeSaasCheckoutPricing(plan: PrecoPlanCard, period: string) {
  const discount = plan.eligiblePeriodDiscount ? PERIOD_DISCOUNT[period] ?? 0 : 0;
  const priceWithDiscount = plan.price * (1 - discount);
  const periodMult =
    period === 'trimestral' ? 3 : period === 'semestral' ? 6 : period === 'anual' ? 12 : 1;
  const total = priceWithDiscount * periodMult;
  return { discount, priceWithDiscount, total, hasDiscount: plan.eligiblePeriodDiscount };
}
